import Model from '../model';





export default Model.extend( {

    endpoint: 'scripts/servers?apiVersion=2.0',
    
    defaults: {
        name: '',
        cluster: null,
        url: '',
        on: true
    },

} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/server.js